<div class="how-it-works-content">
    <h3 i18n>{{mission.name | removehtml}} Rules:</h3>
    <h5 i18n>All rules you need to know:</h5>
    <div class="description" [innerHTML]="description"></div>
</div>